(() => {
  if (customElements.get('yahav-muted-video')) return;
  customElements.define('yahav-muted-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!this.video || !button) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video.muted = true;
      this.userPaused = false;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const syncLabel = () => {
        const audible = !this.video.muted && this.video.volume > 0;
        button.title = audible ? 'Turn video sound off' : 'Turn video sound on';
        button.setAttribute('aria-label', audible ? 'Turn video sound off' : 'Turn video sound on');
        button.setAttribute('aria-pressed', String(audible));
      };
      button.hidden = false;
      syncLabel();
      button.addEventListener('click', () => {
        const audible = !this.video.muted && this.video.volume > 0;
        this.video.muted = audible;
        if (!audible && this.video.volume === 0) this.video.volume = 1;
        syncLabel();
      }, options);
      this.video.addEventListener('volumechange', syncLabel, options);
      this.video.addEventListener('pause', () => {
        if (this.visible && !document.hidden && !this.motion.matches) this.userPaused = true;
      }, options);
      this.video.addEventListener('play', () => { this.userPaused = false; }, options);
      this.sync = () => {
        if (!this.visible || document.hidden || this.motion.matches) this.video.pause();
        else if (!this.userPaused) this.video.play().catch(() => { /* Native controls remain available if autoplay is blocked. */ });
      };
      // Fetch the poster and video data only once the video is close to the screen.
      this.nearObserver = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.nearObserver.disconnect();
        if (this.video.dataset.poster) this.video.poster = this.video.dataset.poster;
        this.video.preload = 'metadata';
      }, { rootMargin: '600px 0px' });
      this.nearObserver.observe(this);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.65;
        this.sync();
      }, { threshold: [0, 0.65] });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.sync, options);
      this.motion.addEventListener('change', this.sync, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.nearObserver?.disconnect();
      this.video?.pause();
    }
  });
})();
